import React, { useState, lazy, Suspense, useEffect } from "react";
import axios from "axios";
import "./App.css";
import Loader from "./components/PostEvent/Loader";
import MediaQuery from "react-responsive";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Combined from "./components/PostEvent/CombinedCarousel/Combined";
import jsonData from "./components/ai-branding.json"; // Import the JSON file

const Body = lazy(() => import("./components/PostEvent/Body/Body"));
// const Releive = lazy(() => import("./components/PostEvent/Releive/PostEventVideos"));
// const ReleiveMobile = lazy(() => import("./components/PostEvent/Releive/MobilePostEventVideo"));
const BodyMobile = lazy(() => import("./components/PostEvent/Body/Bodymobile"));
const Logo = lazy(() => import("./components/PostEvent/Logo Section/Logo.js"));
const Footer = lazy(() => import("./components/PostEvent/Footer/Footer"));
const SignUpForm = lazy(() =>
  import("./components/PostEvent/ContactUS/SignUpForm.js")
);
const Video = lazy(() => import("./components/PostEvent/video.js"));
const PostEventMemories = lazy(() =>
  import("./components/PostEvent/PostEventMemories/PostEventMemories.js")
);

const Thankyou = lazy(() =>
  import("./components/PostEvent/ThankYou/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import(
    "./components/PostEvent/SubscribeNotification/SubscribeForEventNotifications.js"
  )
);
const VideoHighlights = lazy(() =>
  import("./components/PostEvent/VideoHighlights/videoHighlights.js")
);
const MemoriesHighlights = lazy(() =>
  import("./components/PostEvent/MemoryHighlight/MemoriesHighlight.js")
);

const PostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/PostEventVideos.js")
);
const MobilePostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/MobilePostEventVideo.js")
);

function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const appVersion = appversion.version;

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
      >

      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <Body links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <BodyMobile links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>

      <Suspense fallback={<div />}>
        <Logo />
      </Suspense>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <SignUpForm />
        </Suspense>
      </MediaQuery>

      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <MobilePostEventVideo
            handleVideo={handleVideo}
            videoToggle={videoToggle}
          />
        </Suspense>
      </MediaQuery>

      <Suspense fallback={<div />}>
        <PostEventMemories />
      </Suspense>

      <Suspense fallback={<div />}>
        <Thankyou />
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>

      <Combined links={links}/>

      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && (
          <Video handleVideo={handleVideo} videoToggle={videoToggle} />
        )}
      </Suspense>
      </CacheBuster>
    </div>
  );
}

export default App;
